import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowRight, Loader2, Check } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const WaitlistForm = ({ variant = "default", testid = "waitlist", buttonLabel = "Tell me when it launches" }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    const value = email.trim();
    if (!value || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(value)) {
      toast.error("Please enter a valid email address.");
      return;
    }
    setLoading(true);
    try {
      const res = await axios.post(`${API}/waitlist`, { email: value, source: testid });
      setDone(true);
      toast.success(res.data?.already_joined
        ? "You're already on the list — we'll email you the moment we launch."
        : "You're in! We'll email you the moment b→come launches.");
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div
        data-testid={`${testid}-success`}
        className="flex items-center gap-3 rounded-full border border-white/15 bg-white/[0.04] px-6 py-4 text-white"
      >
        <Check className="h-5 w-5 text-gold" />
        <span className="font-medium">You&rsquo;re on the list &mdash; we&rsquo;ll email you the moment we launch.</span>
      </div>
    );
  }

  return (
    <form
      onSubmit={submit}
      data-testid={`${testid}-form`}
      className="flex w-full max-w-xl flex-col gap-3 sm:flex-row"
    >
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Enter your email"
        data-testid={`${testid}-email-input`}
        className="h-14 flex-1 rounded-full border border-white/12 bg-[#0C0C0E] px-6 text-base text-white placeholder:text-muted-foreground outline-none transition-colors focus:border-white/40 focus:ring-2 focus:ring-[#A855F7]/30"
      />
      <button
        type="submit"
        disabled={loading}
        data-testid={`${testid}-submit-btn`}
        className="group inline-flex h-14 items-center justify-center gap-2 rounded-full bg-gradient-brand px-8 text-base font-bold uppercase tracking-wide text-black shadow-[0_14px_50px_-12px_rgba(249,115,22,0.7)] transition-all hover:scale-[1.03] disabled:opacity-70"
      >
        {loading ? (
          <Loader2 className="h-5 w-5 animate-spin" />
        ) : (
          <>
            {buttonLabel}
            <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-1" />
          </>
        )}
      </button>
    </form>
  );
};

export default WaitlistForm;
